export const endpoint = "https://api.societemikalo.com/";
// export const endpoint = "http://localhost:8000/";
export const endpointApi = `${ endpoint }api/v1/`;

export const formattedDate = (date) => {
    if(!date) return null;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const formattedDate = `${ year }-${ month }-${ day }`;

    return formattedDate;
}

export const dateFormat = (date, format="short", hour=false) => {
    format = ['ddmm', 'ddmmm', 'short', 'medium', 'long'].includes(format) ? format : 'short';
    if(!date || /^\d{4}-\d{2}-\d{2}.*$/.test(date) === false) return;

    let dateArray = [];
    if(/^\d{4}-\d{2}-\d{2}T.*$/.test(date)){
        dateArray = date.split('T');
    }else{
        dateArray = date.split(' ');
    }
    
    let months = {
        medium: ["jan", "fév", "mar", "avr", "mai", "jun", "juil", "aoû", "sept", "oct", "nov", "déc"],
        long: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
    };

    if(dateArray.length === 1)
        hour = false;
    dateArray[0] = dateArray[0].split('-');

    if(hour)
        dateArray[1] = dateArray[1].split(':');

    date = dateArray[0][2] + "/" + dateArray[0][1] + "/" + dateArray[0][0];
    
    if(format === "ddmm"){
        date = dateArray[0][2] + "/" + dateArray[0][1];
    }else if(format === "ddmmm"){
        date = dateArray[0][2] + " " + months.medium[parseInt(dateArray[0][1] - 1)];
    }else if(format === "medium"){
        date = dateArray[0][2] + " " + months.medium[parseInt(dateArray[0][1] - 1)] + " " + dateArray[0][0];
    }else if(format === "long"){
        date = dateArray[0][2] + " " + months.long[parseInt(dateArray[0][1] - 1)] + " " + dateArray[0][0];
    }

    if(hour)
        hour = dateArray[1][0] + "h" + dateArray[1][1];

    return date + (hour ? ' ' + hour : '');
}